var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"id":"videoList"}},_vm._l((_vm.posts),function(post,index){return _c('VideoItem',{key:index,staticClass:"videoItem-wrapper",attrs:{"post":post,"index":index}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }